import { useState } from "react";
import { MessageSquare } from "lucide-react";

import type { GrantNotable } from "@/api/grant_notes";
import { Button } from "@/components/ui/button";
import { GrantNotesThread } from "@/components/grant_suite/GrantNotesThread";

type GrantNotesDisclosureProps = {
  municipalityId: number;
  opportunityId: number;
  notable: GrantNotable;
  currentUserId: number | null;
  label?: string;
};

/**
 * A lazily-loaded notes thread behind a toggle. Used on milestone and task rows
 * so the notes fetch only fires when a user opens it, rather than once per row.
 */
export function GrantNotesDisclosure({
  municipalityId,
  opportunityId,
  notable,
  currentUserId,
  label = "Notes",
}: GrantNotesDisclosureProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="space-y-2">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-7 gap-1.5 px-2 text-xs text-muted-foreground"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <MessageSquare className="h-3.5 w-3.5" />
        {open ? "Hide notes" : label}
      </Button>
      {open ? (
        <GrantNotesThread
          municipalityId={municipalityId}
          opportunityId={opportunityId}
          notable={notable}
          currentUserId={currentUserId}
          className="pl-1"
        />
      ) : null}
    </div>
  );
}
